$(function() {
  // モーダルを開く
  $(document).on('click', '[data-modal-link]', function(e) {
      e.preventDefault();
      var target = $(this).data('modalLink');
      modal_open(target);
  });

  // モーダルを閉じる
  $('.js-modal-close').on('click', function(e) {
      e.preventDefault();
      modal_close();
  });
});

// モーダルを開く
function modal_open(target) {
  $('[data-modal-content = ' + target + ']').addClass('is-show');
  $('.modal-bg').addClass('is-show');
}

// モーダルを閉じる
function modal_close() {
  $('[data-modal-content]').removeClass('is-show');
  $('.modal-bg').removeClass('is-show');
}